import React, { useContext, useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Avatar,
  Button,
  CssBaseline,
  TextField,
  Typography,
  Container,
} from "@material-ui/core";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";

// Contexts
import LayoutContext from "../../context/layout/LayoutContext";
import AuthContext from "../../context/auth/AuthContext";

// Components
import Footer from "../layout/Footer";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(5),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.primary.light,
  },
  form: {
    width: "100%",
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

const ChangePassword = () => {
  const classes = useStyles();

  const { setAlert } = useContext(LayoutContext);
  const { user, changePassword, error, clearErrors } = useContext(AuthContext);

  const [submitted, setSubmitted] = useState(false);
  const [updated_time, setUpdatedTime] = useState();

  const pw_details = {
    password_1: "",
    password_2: "",
  };
  const [new_passwords, setNewPasswords] = useState(pw_details);
  const { password_1, password_2 } = new_passwords;

  const onChange = (e) =>
    setNewPasswords({ ...new_passwords, [e.target.name]: e.target.value });

  const onSubmit = (e) => {
    e.preventDefault();

    if (password_1 === "" || password_2 === "") {
      setAlert("Please enter all fields.", "error");
    } else if (password_1 !== password_2) {
      setAlert("Passwords do not match.", "error");
    } else if (password_1.length < 6) {
      setAlert("Please enter a password with 6 or more characters.", "error");
    } else {
      const pw_strength = {
        0: password_1.match(/[A-Z]/),
        1: password_1.match(/[a-z]/),
        2: password_1.match(/\d/),
        3: password_1.match(/[!@#\$%\^\&*\)\(+=._-]/),
      };

      let sum = 0;

      for (let x in pw_strength) {
        sum += pw_strength[x] ? 1 : 0;
      }

      if (sum < 3) {
        setAlert("Please enter a stronger password.", "error");
      } else {
        // Format UTC Date
        const nDate = new Date();
        nDate.setHours(nDate.getHours() + 8);
        const dDate = nDate.toISOString().replace(/T/, " ").replace(/\..+/, "");

        setUpdatedTime(dDate);
        setSubmitted(true);
        changePassword({
          email: user.email,
          password: password_1,
          updated_at: dDate,
        });
      }
    }
  };

  useEffect(() => {
    if (user.updated_at === updated_time) {
      setSubmitted(false);
      setAlert(`Password changed.`, "success");
      setNewPasswords(pw_details);
    }
  }, [user]);

  useEffect(() => {
    if (
      error === "User not found." ||
      error === "New password cannot be the same as your old password."
    ) {
      setSubmitted(false);
      setAlert(error, "error");
      clearErrors();
    }
  }, [error]);

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Change Password{" "}
        </Typography>
        <br />
        <Typography variant="body2" component="p">
          To have a <strong> stronger password </strong>, make sure it: <br />
          & bull; is longer than 6 characters <br />
          & bull; includes upper or lower case letters <br />
          & bull; and numbers <br />& bull; and symbols like!@# $ % ^ & amp;*+ =
          ._ -
        </Typography>
        <form className={classes.form} noValidate onSubmit={onSubmit}>
          <TextField
            required
            fullWidth
            variant="outlined"
            margin="normal"
            type="password"
            id="password_1"
            name="password_1"
            label="New Password"
            value={password_1}
            onChange={onChange}
          />
          <TextField
            required
            fullWidth
            variant="outlined"
            margin="normal"
            type="password"
            id="password_2"
            name="password_2"
            label="Re-enter Your New Password"
            value={password_2}
            onChange={onChange}
          />
          <Button
            fullWidth
            size="large"
            variant="contained"
            color="primary"
            type="submit"
            disabled={submitted}
            className={classes.submit}
          >
            Change Password{" "}
          </Button>{" "}
        </form>{" "}
      </div>
      <Footer marginTop={5} />{" "}
    </Container>
  );
};

export default ChangePassword;
